import fetch from '@/plugin/axios'

// 查询列表
export function getUser (query) {
  return fetch({
    url: '/api/member/account/list',
    method: 'Post',
    data: query
  })
}

// 选项列表
export function getOptions () {
  return fetch({
    url: '/api/member/level/options',
    method: 'Post'
  })
}

// 等级列表
export function getLevel () {
  return fetch({
    url: '/api/member/level/list',
    method: 'Get'
  })
}

// 查询会员信息
export function getInfo (id) {
  return fetch({
    url: `/api/member/level/info/${id}`,
    method: 'Post'
  })
}

// 会员等级编辑
export function getEditId (query, id) {
  return fetch({
    url: `/api/member/level/edit/${id}`,
    method: 'Post',
    data: query
  })
}

// 会员等级编辑
export function getAccountInfo (id) {
  return fetch({
    url: `/api/member/account/info/${id}`,
    method: 'Get'
  })
}

// 领钻记录
export function getLead (query) {
  return fetch({
    url: '/api/common/point-log/list',
    method: 'Post',
    data: query
  })
}

// 查询用户证书列表
export function getUserCerts (query) {
  return fetch({
    url: '/api/member/user-cert/user-certs',
    method: 'get',
    params: query
  })
}

// 赠送用户经验值
export function getGive (query) {
  return fetch({
    url: '/api/member/account/send-point',
    method: 'Post',
    params: query
  })
}
// 赠送用户属性
export function getAttr (query) {
  return fetch({
    url: '/api/member/user-cert/attr/add',
    method: 'Post',
    data: query
  })
}
export function getUserAttrs (userCertId) {
  return fetch({
    url: `/api/member/user-cert/attr/${userCertId}`,
    method: 'Get'
  })
}
// 虚拟账户导入模板
export function importModal () {
  return fetch({
    url: '/api/member/account/virtual/import/tmp',
    method: 'Get',
    responseType: 'blob'
  })
}

// 虚拟账户导入
export function importData (params) {
  return fetch({
    url: '/api/member/account/virtual/import',
    method: 'Post',
    data: params,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function addUserTag (data) {
  return fetch({
    url: '/api/member/user-tag/add',
    method: 'Post',
    data: data
  })
}

// 关键字列表
export function getUserTagList (data) {
  return fetch({
    url: '/api/member/user-tag/list',
    method: 'Post',
    data: data
  })
}

export function getUserTagOption () {
  return fetch({
    url: '/api/member/user-tag/option',
    method: 'Get'
  })
}

// 删除关键字
export function removeUserTag (id) {
  return fetch({
    url: `/api/member/user-tag/remove/${id}`,
    method: 'Delete'
  })
}

// 关键字信息
export function getUserTagInfo (id) {
  return fetch({
    url: `/api/member/user-tag/info/${id}`,
    method: 'Get'
  })
}

// 修改关键字
export function updateUserTag (id, data) {
  return fetch({
    url: `/api/member/user-tag/update/${id}`,
    method: 'Post',
    data: data
  })
}

export function getUserTageByUserId (userId) {
  return fetch({
    url: `/api/member/account/user/tags/${userId}`,
    method: 'Get'
  })
}

export function addUserHasTags (data) {
  return fetch({
    url: `/api/member/user-has-tag/add`,
    method: 'Post',
    data: data
  })
}

export function tagOptions (type) {
  let url = `/api/member/user-tag/options`
  if (type) {
    url = `/api/member/user-tag/options?type=${type}`
  }
  return fetch({
    url: url,
    method: 'Get'
  })
}
